"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const onChangeHandlers = [];
const getAccount = () => {
    return JSON.parse(localStorage.getItem('account') || '{}');
};
// Anytime `setAccount` is called, all callbacks are fired.
// This allows the hooks and HOCs defined in withAccount to
// update their respective depencies.
const setAccount = (account) => {
    localStorage.setItem('account', JSON.stringify(account));
    onChangeHandlers.forEach((fn) => fn());
};
const LocalAccount = {
    get: getAccount,
    getId: () => getAccount().id,
    set: (account) => setAccount(account),
    registerOnChange: (func) => onChangeHandlers.push(func),
    PropTypes: { accountId: prop_types_1.default.string }
};
Object.freeze(LocalAccount);
exports.default = LocalAccount;
